import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
  title: string;
  message: string;
  open: boolean;
  onContinueClick: () => void;
  onCancelClick: () => void;
}

class AlertDialog extends React.Component<Props> {
  render() {
    const { title, message, open, onContinueClick, onCancelClick } = this.props;
    return (
      <Dialog open={open} onClose={onCancelClick}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancelClick} color="primary">
            Cancelar
          </Button>
          <Button onClick={onContinueClick} color="primary" autoFocus={true}>
            Continuar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/components/AlertDialog.tsx